export default __webpack_public_path__ + "static/anonymousRibbon-9246fd9ccc19b4f7817d307f14d8bfe1.svg";